import React, { useEffect, createContext, useState } from 'react';
import { auth, fireStore } from "./firebase_context";
import { signInAnonymously } from "firebase/auth";
import { collection, addDoc, getDocs, query, where } from 'firebase/firestore';


export const AuthContext = createContext({});

export const AuthProvider = (props) => {
    const [isAuthenticated, makeAuthenticated] = useState(false);
    const [loggedInUser, setLoggedInUser] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const checkAuth = async () => {
            auth.onAuthStateChanged(async function (user) {
                if (user && !loggedInUser) {
                    makeAuthenticated(true);
                    loadUser(user.uid);
                }
                else if (!user && !isLoading) {
                    loginUser();
                }
            });
        }
        if (!isLoading) {
            setIsLoading(true);
            checkAuth().catch(console.error);
        }
    }, []);

    function reloadUser() {
        if (auth.currentUser) {
            loadUser(auth.currentUser.uid);
        }
    }

    function loginUser() {
        setIsLoading(true);
        signInAnonymously(auth).catch(error => {
            console.log('Login Error', error);
            makeAuthenticated(false);
            setLoggedInUser(null);
            setIsLoading(false);
        });
    }

    async function createUserWithId(uid) {
        try {
            const u = {
                uid: uid,
                current_score: 0,
                current_score_hard: 0,
                streak: 0,
                max_score_hits: 0,
                max_score_hits_hard: 0,
                previous_scores: [],
            };
            const doc = await addDoc(collection(fireStore, 'users'), u);
            makeAuthenticated(true);
            setLoggedInUser({ ...u, id: doc.id });
        } catch (err) {
            console.log(err);
            makeAuthenticated(false);
            setLoggedInUser(null);
        }
    }
    
    async function loadUser(uid) {
        setIsLoading(true);
        const snapshot = await getDocs(query(collection(fireStore, 'users'), where("uid", "==", uid)));
        if (snapshot.docs.length > 0) {
            const data = { ...snapshot.docs[0].data() };
            const docId = snapshot.docs[0].id;
            setLoggedInUser({...data, id: docId});
            setIsLoading(false);
                   
            return;
        } else {
            await createUserWithId(uid);
            setIsLoading(false)
        }
    }


    return (
        <AuthContext.Provider
            value={{
                isAuthenticated,
                loggedInUser,
                loginUser,
                reloadUser,
            }}
        >
            {props.children}
        </AuthContext.Provider>
    );
};

export default AuthProvider;